var _rect, _use, _polygon, _use2, _use3, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "736px",
    height: "900px",
    viewBox: "0 0 736 900",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Register",
    transform: "translate(-705.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(705.000000, 0.000000)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#ED7D32",
    x: 0,
    y: 0,
    width: 735,
    height: 900
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#ED7D32",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "url(#pattern-2)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#CC5B0F",
    fillRule: "nonzero",
    points: "535 200 735 200 735 400 535 400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(635.000000, 100.000000) scale(-1, 1) rotate(-270.000000) translate(-635.000000, -100.000000) "
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#ED7D32",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "url(#pattern-5)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#E36E20",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.2,
    fill: "url(#pattern-8)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#D17537",
    fillRule: "nonzero",
    transform: "translate(635.000000, 800.000000) scale(-1, 1) rotate(-270.000000) translate(-635.000000, -800.000000) ",
    points: "535 700 735 700 735 900"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgOrange);
export default __webpack_public_path__ + "static/media/bg-orange.8a9ab6d6.svg";
export { ForwardRef as ReactComponent };